'use client';

import { useId, useState, type ReactNode } from 'react';

export default function CodeTabs({ labels, panels }: { labels: string[]; panels: ReactNode[] }) {
  const [active, setActive] = useState(0);
  const id = useId();
  return (
    <div>
      <div role="tablist" aria-label="Code language" className="flex flex-wrap gap-2 mb-3">
        {labels.map((label, index) => (
          <button key={index} type="button" role="tab" id={`${id}-tab-${index}`} aria-controls={`${id}-panel-${index}`} aria-selected={active === index} tabIndex={active === index ? 0 : -1} onClick={() => setActive(index)} onKeyDown={(event) => {
            const next = event.key === 'ArrowRight' ? (index + 1) % labels.length : event.key === 'ArrowLeft' ? (index + labels.length - 1) % labels.length : event.key === 'Home' ? 0 : event.key === 'End' ? labels.length - 1 : null;
            if (next !== null) { event.preventDefault(); setActive(next); document.getElementById(`${id}-tab-${next}`)?.focus(); }
          }} className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${active === index ? 'study-filter-active' : 'study-filter-idle'}`}>
            {label}
          </button>
        ))}
      </div>
      {panels.map((panel, index) => <div key={index} role="tabpanel" tabIndex={0} id={`${id}-panel-${index}`} aria-labelledby={`${id}-tab-${index}`} hidden={active !== index}>{active === index ? panel : null}</div>)}
    </div>
  );
}
